<div class="flex items-center gap-3 flex-1 min-w-0">

  <!-- ===== MOBILE LAYOUT (hidden on md+) ===== -->
  <div class="mobile-layout-block flex-col w-full gap-4">
    <!-- Row 1: search -->
    <div class="relative w-full" *ngIf="mode === 'list' || !mode">
      <msc-common-search class=" rounded-full px-4 h-9 w-full" trigger="auto" [placeholder]="searchPlaceholder"
        (searchEvent)="search($event.value)">
      </msc-common-search>
    </div>
    <!-- Row 2: Filtros + tabs -->
    <div class="mobile-tabs-row items-center gap-2 overflow-x-auto no-scrollbar">
      <!-- Filtros button -->
      <button type="button"
        class="flex-shrink-0 flex items-center gap-1.5 h-8 px-3 rounded-full border border-gray-200 bg-white text-[13px] text-gray-600 font-medium shadow-sm"
        (click)="mobileFiltersClick.emit()">
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="21" x2="14" y1="4" y2="4"></line><line x1="10" x2="3" y1="4" y2="4"></line>
          <line x1="21" x2="12" y1="12" y2="12"></line><line x1="8" x2="3" y1="12" y2="12"></line>
          <line x1="21" x2="16" y1="20" y2="20"></line><line x1="12" x2="3" y1="20" y2="20"></line>
          <line x1="14" x2="14" y1="2" y2="6"></line><line x1="8" x2="8" y1="10" y2="14"></line>
          <line x1="16" x2="16" y1="18" y2="22"></line>
        </svg>
        {{ 'words.filters' | translate }}
      </button>
      <!-- Subscription tabs (catalogue) -->
      <ng-container *ngIf="type === 'catalogue'">
        <button type="button"
          class="flex-shrink-0 h-8 px-3 rounded-full border text-[13px] font-medium transition-colors"
          [ngClass]="!subscriptionFilter ? 'border-gray-800 bg-gray-800 text-white' : 'border-gray-200 bg-white text-gray-600'"
          (click)="onSubscriptionTabClick(null)">
          {{ 'words.all' | translate }}
        </button>
        <button type="button"
          class="flex-shrink-0 h-8 px-3 rounded-full border text-[13px] font-medium transition-colors"
          [ngClass]="subscriptionFilter === 'subscribed' ? 'border-gray-800 bg-gray-800 text-white' : 'border-gray-200 bg-white text-gray-600'"
          (click)="onSubscriptionTabClick('subscribed')">
          {{ 'group.team.cards.enrolled' | translate }}
        </button>
        <button type="button"
          class="flex-shrink-0 h-8 px-3 rounded-full border text-[13px] font-medium transition-colors"
          [ngClass]="subscriptionFilter === 'not_subscribed' ? 'border-gray-800 bg-gray-800 text-white' : 'border-gray-200 bg-white text-gray-600'"
          (click)="onSubscriptionTabClick('not_subscribed')">
          {{ 'words.not-subscribed' | translate }}
        </button>
      </ng-container>
      <!-- Status tabs (mis cursos) -->
      <ng-container *ngIf="statusOptions && statusOptions.length > 0">
        <button *ngFor="let status of filteredStatusOptions" type="button"
          class="flex-shrink-0 h-8 px-3 rounded-full border text-[13px] font-medium transition-colors"
          [ngClass]="(status.value === 'all' && !hasActiveStatus) || (status.value !== 'all' && status.isSelected)
            ? 'border-gray-800 bg-gray-800 text-white'
            : 'border-gray-200 bg-white text-gray-600'"
          (click)="onStatusTabClick(status.value)">
          {{ status.label }}
        </button>
      </ng-container>

      <!-- Separador -->
      <div class="flex-shrink-0 w-[0.5px] h-6 bg-gray-200 mx-1"></div>

      <!-- Guardados - Solo icono, sólo mis cursos -->
      <button type="button" *ngIf="type !== 'catalogue'" [tooltip]="'word-saved' | translate"
        class="flex-shrink-0 w-8 h-8 flex items-center justify-center border rounded-md bg-white transition-colors cursor-pointer shadow-sm"
        [ngClass]="activeSaved ? 'text-secondary-500 border-secondary-300' : 'text-muted-foreground border-foreground/10'"
        (click)="toggleSaved()">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
          class="lucide lucide-bookmark w-[15px] h-[15px]" [attr.fill]="activeSaved ? 'currentColor' : 'none'">
          <path d="m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16z"></path>
        </svg>
      </button>

      <!-- ORDENAR Sort button + dropdown (oculto en Mis Cursos) -->
      <div class="relative flex-shrink-0" *ngIf="type !== 'content'">
        <div *ngIf="showSortDropdown" class="fixed inset-0 z-40" (click)="showSortDropdown = false"></div>
        <button type="button"
          class="h-8 px-2.5 inline-flex items-center gap-1 border font-normal border-foreground/10 rounded-md bg-white text-[13px] text-gray-500 transition-colors cursor-pointer shadow-sm whitespace-nowrap"
          (click)="toggleSortDropdown()">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
            class="lucide lucide-arrow-up-down w-[13px] h-[15px]">
            <path d="m21 16-4 4-4-4"></path>
            <path d="M17 20V4"></path>
            <path d="m3 8 4-4 4 4"></path>
            <path d="M7 4v16"></path>
          </svg>
        </button>
        <div *ngIf="showSortDropdown"
          class="absolute left-0 top-full mt-2 w-60 bg-white rounded-xl shadow-lg border border-foreground/10 py-1.5 z-50">
          <button *ngFor="let opt of selectOrderOptions" type="button"
            class="w-full flex items-center gap-2.5 px-3 py-2 text-[13px] text-left transition-colors"
            [ngClass]="opt.isSelected ? 'text-gray-500 bg-muted/40' : 'text-gray-500 hover:bg-muted/40'"
            (click)="onSelectOption(opt)">
            <ng-container [ngSwitch]="opt.value">
              <svg *ngSwitchCase="'-date'" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="lucide lucide-trending-up w-4 h-4 flex-shrink-0">
                <polyline points="22 7 13.5 15.5 8.5 10.5 2 17"></polyline>
                <polyline points="16 7 22 7 22 13"></polyline>
              </svg>
              <svg *ngSwitchCase="'title'" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="lucide lucide-arrow-down-az w-4 h-4 flex-shrink-0">
                <path d="m3 16 4 4 4-4"></path><path d="M7 20V4"></path><path d="M20 8h-5"></path>
                <path d="M15 10V6.5a2.5 2.5 0 0 1 5 0V10"></path><path d="M15 14h5l-5 6h5"></path>
              </svg>
              <svg *ngSwitchCase="'-title'" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="lucide lucide-arrow-up-az w-4 h-4 flex-shrink-0">
                <path d="m3 8 4-4 4 4"></path><path d="M7 4v16"></path><path d="M20 8h-5"></path>
                <path d="M15 10V6.5a2.5 2.5 0 0 1 5 0V10"></path><path d="M15 14h5l-5 6h5"></path>
              </svg>
            </ng-container>
            <span class="flex-1 text-gray-500 text-[13px]">{{ opt.label }}</span>
            <svg *ngIf="opt.isSelected" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
              fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              class="lucide lucide-check w-4 h-4 flex-shrink-0">
              <path d="M20 6 9 17l-5-5"></path>
            </svg>
          </button>
        </div>
      </div>

      <!-- Grid / List toggle -->
      <div class="flex-shrink-0 flex items-center gap-1 h-8 rounded-md p-1 bg-muted/40" style="border: 0.5px solid hsl(var(--border));">
        <button type="button" class="w-7 h-6 flex items-center justify-center rounded-sm transition-colors cursor-pointer"
          [ngClass]="viewMode === 'grid' ? 'bg-white shadow-sm text-destructive' : 'text-muted-foreground'"
          (click)="setViewMode('grid')">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
            class="lucide lucide-layout-grid w-3 h-3">
            <rect width="7" height="7" x="3" y="3" rx="1"></rect>
            <rect width="7" height="7" x="14" y="3" rx="1"></rect>
            <rect width="7" height="7" x="14" y="14" rx="1"></rect>
            <rect width="7" height="7" x="3" y="14" rx="1"></rect>
          </svg>
        </button>
        <button type="button" class="w-7 h-6 flex items-center justify-center rounded-sm transition-colors cursor-pointer"
          [ngClass]="viewMode === 'list' ? 'bg-white shadow-sm text-destructive' : 'text-muted-foreground'"
          (click)="setViewMode('list')">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
            class="lucide lucide-list w-3 h-3">
            <path d="M3 12h.01"></path><path d="M3 18h.01"></path><path d="M3 6h.01"></path>
            <path d="M8 12h13"></path><path d="M8 18h13"></path><path d="M8 6h13"></path>
          </svg>
        </button>
      </div>
    </div>
  </div>

  <!-- ===== DESKTOP LAYOUT (hidden on mobile) ===== -->
  <div class="hidden md:flex items-center gap-3 flex-1 min-w-0">
    <msc-common-search class=" rounded-full px-4 h-9" trigger="auto" [placeholder]="searchPlaceholder"
      (searchEvent)="search($event.value)">
    </msc-common-search>
  </div>

  <!-- Controles (alineados a la derecha, sólo mis cursos) -->
  <div class="hidden md:flex items-center gap-2.5 ">
    <!-- Filtro de progreso -->
    <div class="flex items-center rounded-full p-1 h-9 text-sm bg-muted/40"
      style="border: 0.5px solid hsl(var(--border));" *ngIf="statusOptions && statusOptions.length > 0">
      <button *ngFor="let status of filteredStatusOptions" type="button"
        class="text-[13px] px-3.5 h-full flex items-center justify-center rounded-full font-medium transition-colors cursor-pointer"
        [ngClass]="(status.value === 'all' && !hasActiveStatus) || (status.value !== 'all' && status.isSelected)
          ? 'bg-white text-gray-600 shadow-sm'
          : 'text-gray-500 hover:text-gray-600'" (click)="onStatusTabClick(status.value)">
        {{ status.label }}
      </button>
    </div>

    <!-- Filtro de inscripción (switcher, sólo catálogo) -->
    <div class="flex items-center rounded-full p-1 h-9 text-sm bg-muted/40"
      style="border: 0.5px solid hsl(var(--border));" *ngIf="type === 'catalogue'">
      <button type="button"
        class="text-[13px] px-3.5 h-full flex items-center justify-center rounded-full font-medium transition-colors cursor-pointer"
        [ngClass]="!subscriptionFilter ? 'bg-white text-gray-600 shadow-sm' : 'text-gray-500 hover:text-gray-600'"
        (click)="onSubscriptionTabClick(null)">
        {{ 'words.all' | translate }}
      </button>
      <button type="button"
        class="text-[13px] px-3.5 h-full flex items-center justify-center rounded-full font-medium transition-colors cursor-pointer"
        [ngClass]="subscriptionFilter === 'subscribed' ? 'bg-white text-gray-600 shadow-sm' : 'text-gray-500 hover:text-gray-600'"
        (click)="onSubscriptionTabClick('subscribed')">
        {{ 'group.team.cards.enrolled' | translate }}
      </button>
      <button type="button"
        class="text-[13px] px-3.5 h-full flex items-center justify-center rounded-full font-medium transition-colors cursor-pointer"
        [ngClass]="subscriptionFilter === 'not_subscribed' ? 'bg-white text-gray-600 shadow-sm' : 'text-gray-500 hover:text-gray-600'"
        (click)="onSubscriptionTabClick('not_subscribed')">
        {{ 'words.not-subscribed' | translate }}
      </button>
    </div>

    <div class="w-[0.5px] h-7 bg-gray-200 "></div>
    <!-- Ranking - Botón con dropdown, sólo mis cursos -->
    <div class="relative" *ngIf="type !== 'catalogue'" [tooltip]="'words.ranking' | translate">
      <div *ngIf="showRankingDropdown" class="fixed inset-0 z-40" (click)="showRankingDropdown = false">
      </div>

      <button type="button" title="Ranking"
        class="w-9 h-9 flex items-center justify-center border border-foreground/10 rounded-md bg-white transition-colors cursor-pointer shadow-sm"
        [ngClass]="hasActiveRanking ? 'text-secondary-500 border-secondary-300' : 'text-muted-foreground hover:text-foreground'"
        (click)="toggleRankingDropdown()">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
          class="lucide lucide-trending-up w-[16px] h-[16px]">
          <polyline points="22 7 13.5 15.5 8.5 10.5 2 17"></polyline>
          <polyline points="16 7 22 7 22 13"></polyline>
        </svg>
      </button>

      <!-- Dropdown ranking -->
      <div *ngIf="showRankingDropdown"
        class="absolute right-0 top-full mt-2 w-64 bg-white rounded-xl shadow-lg border border-foreground/10 py-1.5 z-50">
        <div class="px-3 py-1.5 text-[11px] font-semibold uppercase tracking-wide text-muted-foreground">
          {{'words.ranking' | translate}}</div>

        <!-- Mejores calificados -->
        <button type="button" class="w-full flex items-center gap-2.5 px-3 py-2 text-[13px] text-left transition-colors"
          [ngClass]="rankingOptions[0].isSelected ? 'text-gray-700 bg-muted/40' : 'text-gray-500 hover:bg-muted/40'"
          (click)="onSelectRanking(rankingOptions[0])">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
            class="lucide lucide-trophy w-4 h-4 flex-shrink-0">
            <path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6"></path>
            <path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18"></path>
            <path d="M4 22h16"></path>
            <path d="M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22"></path>
            <path d="M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22"></path>
            <path d="M18 2H6v7a6 6 0 0 0 12 0V2Z"></path>
          </svg>
          <span class="flex-1">{{ rankingOptions[0].label }}</span>
          <svg *ngIf="rankingOptions[0].isSelected" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round" class="lucide lucide-check w-4 h-4 flex-shrink-0">
            <path d="M20 6 9 17l-5-5"></path>
          </svg>
        </button>

        <!-- Menor calificación -->
        <button type="button" class="w-full flex items-center gap-2.5 px-3 py-2 text-[13px] text-left transition-colors"
          [ngClass]="rankingOptions[1].isSelected ? 'text-gray-700 bg-muted/40' : 'text-gray-500 hover:bg-muted/40'"
          (click)="onSelectRanking(rankingOptions[1])">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
            class="lucide lucide-arrow-up-az w-4 h-4 flex-shrink-0">
            <path d="m3 8 4-4 4 4"></path>
            <path d="M7 4v16"></path>
            <path d="M20 8h-5"></path>
            <path d="M15 10V6.5a2.5 2.5 0 0 1 5 0V10"></path>
            <path d="M15 14h5l-5 6h5"></path>
          </svg>
          <span class="flex-1">{{ rankingOptions[1].label }}</span>
          <svg *ngIf="rankingOptions[1].isSelected" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round" class="lucide lucide-check w-4 h-4 flex-shrink-0">
            <path d="M20 6 9 17l-5-5"></path>
          </svg>
        </button>

        <!-- Sin calificación -->
        <button type="button" class="w-full flex items-center gap-2.5 px-3 py-2 text-[13px] text-left transition-colors"
          [ngClass]="rankingOptions[2].isSelected ? 'text-gray-700 bg-muted/40' : 'text-gray-500 hover:bg-muted/40'"
          (click)="onSelectRanking(rankingOptions[2])">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
            class="lucide lucide-sparkles w-4 h-4 flex-shrink-0">
            <path
              d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z">
            </path>
            <path d="M20 3v4"></path>
            <path d="M22 5h-4"></path>
            <path d="M4 17v2"></path>
            <path d="M5 18H3"></path>
          </svg>
          <span class="flex-1">{{ rankingOptions[2].label }}</span>
          <svg *ngIf="rankingOptions[2].isSelected" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round" class="lucide lucide-check w-4 h-4 flex-shrink-0">
            <path d="M20 6 9 17l-5-5"></path>
          </svg>
        </button>
      </div>
    </div>

    <!-- Guardados - Solo icono, sólo mis cursos -->
    <button type="button" *ngIf="type !== 'catalogue'" [tooltip]="'word-saved' | translate"
      class="w-9 h-9 flex items-center justify-center border rounded-md bg-white transition-colors cursor-pointer shadow-sm"
      [ngClass]="activeSaved ? 'text-secondary-500 border-secondary-300' : 'text-muted-foreground border-foreground/10 hover:text-foreground'"
      (click)="toggleSaved()">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
        class="lucide lucide-bookmark w-[16px] h-[16px]" [attr.fill]="activeSaved ? 'currentColor' : 'none'">
        <path d="m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16z"></path>
      </svg>
    </button>

    <!-- ORDENAR Sort button + dropdown (oculto en Mis Cursos) -->
    <div class="relative" *ngIf="type !== 'content'" [tooltip]="'words.order' | translate">
      <!-- Backdrop para cerrar el dropdown -->
      <div *ngIf="showSortDropdown" class="fixed inset-0 z-40" (click)="showSortDropdown = false">
      </div>

      <button type="button"
        class="h-9 px-3 inline-flex items-center gap-1.5 border font-normal border-foreground/10 rounded-md bg-white text-[13px] text-gray-500 hover:bg-muted/40 transition-colors cursor-pointer shadow-sm whitespace-nowrap"
        (click)="toggleSortDropdown()">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
          class="lucide lucide-arrow-up-down w-[14px] h-[16px]">
          <path d="m21 16-4 4-4-4"></path>
          <path d="M17 20V4"></path>
          <path d="m3 8 4-4 4 4"></path>
          <path d="M7 4v16"></path>
        </svg>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
          class="lucide lucide-chevron-down hidden  w-4 h-4 text-muted-foreground transition-transform"
          [class.rotate-180]="showSortDropdown">
          <path d="m6 9 6 6 6-6"></path>
        </svg>
      </button>

      <!-- Dropdown opciones de orden -->
      <div *ngIf="showSortDropdown"
        class="absolute right-0 top-full mt-2 w-60 bg-white rounded-xl shadow-lg border border-foreground/10 py-1.5 z-50">
        <button *ngFor="let opt of selectOrderOptions" type="button"
          class="w-full flex items-center gap-2.5 px-3 py-2 text-[13px] text-left transition-colors" [ngClass]="opt.isSelected 
            ? 'text-gray-500 bg-muted/40' 
            : 'text-gray-500 hover:bg-muted/40'" (click)="onSelectOption(opt)">

          <!-- Icon based on option -->
          <ng-container [ngSwitch]="opt.value">
            <!-- Trending up icon for most recent -->
            <svg *ngSwitchCase="'-date'" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
              fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              class="lucide lucide-trending-up w-4 h-4 flex-shrink-0">
              <polyline points="22 7 13.5 15.5 8.5 10.5 2 17"></polyline>
              <polyline points="16 7 22 7 22 13"></polyline>
            </svg>
            <!-- A-Z icon -->
            <svg *ngSwitchCase="'title'" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
              fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              class="lucide lucide-arrow-down-az w-4 h-4 flex-shrink-0">
              <path d="m3 16 4 4 4-4"></path>
              <path d="M7 20V4"></path>
              <path d="M20 8h-5"></path>
              <path d="M15 10V6.5a2.5 2.5 0 0 1 5 0V10"></path>
              <path d="M15 14h5l-5 6h5"></path>
            </svg>
            <!-- Z-A icon -->
            <svg *ngSwitchCase="'-title'" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
              fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              class="lucide lucide-arrow-up-az w-4 h-4 flex-shrink-0">
              <path d="m3 8 4-4 4 4"></path>
              <path d="M7 4v16"></path>
              <path d="M20 8h-5"></path>
              <path d="M15 10V6.5a2.5 2.5 0 0 1 5 0V10"></path>
              <path d="M15 14h5l-5 6h5"></path>
            </svg>
          </ng-container>

          <span class="flex-1 text-gray-500 text-[13px]">{{ opt.label }}</span>

          <!-- Check icon when selected -->
          <svg *ngIf="opt.isSelected" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
            fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
            class="lucide lucide-check w-4 h-4 flex-shrink-0">
            <path d="M20 6 9 17l-5-5"></path>
          </svg>
        </button>
      </div>
    </div>

    <!-- Grid / List toggle -->
    <div class="flex items-center gap-1 h-9 rounded-md p-1 bg-muted/40" style="border: 0.5px solid hsl(var(--border));">
      <button type="button" class="w-8 h-7 flex items-center justify-center rounded-sm transition-colors cursor-pointer"
        [ngClass]="viewMode === 'grid'
          ? 'bg-white shadow-sm text-primary'
          : 'text-muted-foreground hover:text-foreground'" (click)="setViewMode('grid')">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
          class="lucide lucide-layout-grid w-3.5 h-3.5">
          <rect width="7" height="7" x="3" y="3" rx="1"></rect>
          <rect width="7" height="7" x="14" y="3" rx="1"></rect>
          <rect width="7" height="7" x="14" y="14" rx="1"></rect>
          <rect width="7" height="7" x="3" y="14" rx="1"></rect>
        </svg>
      </button>
      <button type="button" class="w-8 h-7 flex items-center justify-center rounded-sm transition-colors cursor-pointer"
        [ngClass]="viewMode === 'list'
          ? 'bg-white shadow-sm text-primary'
          : 'text-muted-foreground hover:text-foreground'" (click)="setViewMode('list')">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
          class="lucide lucide-list w-3.5 h-3.5">
          <path d="M3 12h.01"></path>
          <path d="M3 18h.01"></path>
          <path d="M3 6h.01"></path>
          <path d="M8 12h13"></path>
          <path d="M8 18h13"></path>
          <path d="M8 6h13"></path>
        </svg>
      </button>
    </div>
  </div>

</div>